import KHCLottie from './KHCLottie';

export default function FullPageSpinner() {
	return <KHCLottie isFullPage/>;
}
